import { useEffect, useRef } from "react";
import { actions, ROW } from "./uploadPackageReducer";

// sad §7: the cabinet processes at most 3 files of a package at once (RSA pair → key → encrypt → submit).
export const MAX_CONCURRENT_SUBMISSIONS = 3;

// An RTK Query error with an HTTP status keeps the server envelope; anything else — a network
// failure, a parsing error, a failed key generation — is a transport failure.
export function toUploadFailure(error) {
  if (error && typeof error.status === "number") {
    const data = error.data || {};
    return { status: error.status, code: data.code, commonMessage: data.commonMessage, details: data.details };
  }
  return { transport: true };
}

function useSubmissionQueue(rows, dispatch, submitFile, concurrency = MAX_CONCURRENT_SUBMISSIONS) {
  const inFlight = useRef(new Set());
  const submitRef = useRef(submitFile);

  useEffect(() => {
    submitRef.current = submitFile;
  }, [submitFile]);

  useEffect(() => {
    const free = concurrency - inFlight.current.size;
    if (free <= 0) return;

    rows
      .filter((row) => row.state === ROW.PROCESSING && !row.active && !inFlight.current.has(row.clientId))
      .slice(0, free)
      .forEach((row) => {
        const { clientId } = row;
        inFlight.current.add(clientId);
        dispatch(actions.uploadStarted(clientId));
        Promise.resolve()
          .then(() => submitRef.current(row))
          .then(
            (report) => {
              inFlight.current.delete(clientId);
              dispatch(actions.uploadSucceeded(clientId, report));
            },
            (error) => {
              inFlight.current.delete(clientId);
              dispatch(actions.uploadFailed(clientId, toUploadFailure(error)));
            },
          );
      });
  }, [rows, dispatch, concurrency]);
}

export default useSubmissionQueue;
